import React, { type ReactElement } from 'react';
import { FormControl, Grid, IconButton, MenuItem, Select, type SelectChangeEvent } from '@mui/material';

import useOrder, { type OrderProps } from '../hooks/useOrder';
import useSettings from '../hooks/useSettings';
import Icon from '../Icon';

type PaginationOrderProps = {
	module: string;
} & OrderProps;

function PaginationOrder(props: PaginationOrderProps) {
	const { settings, t } = useSettings(props.module);

	const { orderBy, orderOperator, setOrderBy, setOrderOperator } = useOrder(props);

	function handleChange(event: SelectChangeEvent<string>) {
		if (event.target.value !== 'none') {
			setOrderBy(event.target.value);
			setOrderOperator(orderOperator || 'asc');
		} else {
			setOrderBy('');
			setOrderOperator('');
		}
	}

	function changeOrderOperator() {
		setOrderOperator(orderOperator === 'asc' ? 'desc' : 'asc');
	}

	const items: ReactElement[] = [];
	if (settings?.filter_types)
		settings.filter_types.forEach(element => {
			if (element.filt_sortable) {
				items.push(
					<MenuItem key={element.filt_field} value={element.filt_field} dense>
						{t(element.filt_label)}
					</MenuItem>
				);
			}
		});

	return (
		<Grid container alignItems="center" spacing={1}>
			<Grid>
				<FormControl variant="outlined">
					<Select size="small" value={orderBy || 'none'} onChange={handleChange}>
						<MenuItem value="none" dense>
							<em>{t('ORDER_DEFAULT')}</em>
						</MenuItem>
						{items}
					</Select>
				</FormControl>
			</Grid>
			<Grid>
				<IconButton size="small" onClick={changeOrderOperator} disabled={!orderBy}>
					<Icon icon={orderOperator === 'desc' ? 'sort-descending' : 'sort-ascending'} />
				</IconButton>
			</Grid>
		</Grid>
	);
}

export default React.memo(PaginationOrder);
